<template>
  <div class="shop">
    <el-button
      size="small"
      style="float:right;margin-bottom:20px"
      type="primary"
      @click="addItem"
      >添加</el-button
    >
    <el-table
      :data="tableData"
      max-height="720"
      :cell-style="tc"
      :header-cell-style="tccolor"
    >
      <el-table-column label="序号" prop="id"></el-table-column>
      <el-table-column label="所属活动" prop="activity_name"></el-table-column>
      <el-table-column label="分类名称" prop="sort_name"></el-table-column>
      <el-table-column label="排序" prop="sort_order"></el-table-column>
      <el-table-column label="商品数" prop="goods_num"></el-table-column>
      <el-table-column label="操作" fixed="right" width="200">
        <template slot-scope="scope">
          <el-button size="mini" @click="editItem(scope.row)">编辑</el-button>
          <el-button size="mini" type="primary" @click="deleteItem(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-col :span="24">
      <div class="pagination">
        <el-pagination
          background
          @current-change="pageChange"
          :current-page="form.page"
          :page-size="form.size"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-col>
    <!--添加弹窗-->
    <jdialog title="添加活动" :visible.sync="isShowAddWindow" width="640px">
      <el-form
        :model="addWindowInfo"
        ref="ruleForm"
        class="demo-ruleForm"
        label-width="80px"
      >
        <el-form-item label="分类名称">
          <el-input
            type="text"
            placeholder="分类名称"
            v-model="addWindowInfo.sort_name"
          ></el-input>
        </el-form-item>
        <el-form-item label="分类排序">
          <el-input
            type="text"
            placeholder="分类排序，数字越大越靠前"
            v-model="addWindowInfo.sort_order"
          ></el-input>
        </el-form-item>
        <el-form-item label="所属活动">
          <el-select
            size="small"
            v-model="addWindowInfo.activity_id"
            filterable
            class="select"
            placeholder="请选择所属活动"
          >
            <el-option
              v-for="item in activits"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <div class="align">
        <el-button size="mini" @click="isShowAddWindow = false">取消</el-button>
        <el-button size="mini" type="primary" @click="creatAdd">确定</el-button>
      </div>
    </jdialog>
    <!--编辑弹窗-->
    <jdialog title="编辑活动" :visible.sync="isShowEditWindow" width="640px">
      <el-form
        :model="windowInfo"
        ref="ruleForm"
        class="demo-ruleForm"
        label-width="80px"
      >
        <el-form-item label="分类名称">
          <el-input
            type="text"
            placeholder="分类名称"
            v-model="windowInfo.sort_name"
          ></el-input>
        </el-form-item>
        <el-form-item label="分类排序">
          <el-input
            type="num"
            placeholder="分类排序，数字越大越靠前"
            v-model="windowInfo.sort_order"
          ></el-input>
        </el-form-item>
        <el-form-item label="所属活动">
          <el-select
            size="small"
            v-model="windowInfo.activity_id"
            filterable
            class="select"
            placeholder="请选择所属活动"
          >
            <el-option
              v-for="item in activits"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <div class="align">
        <el-button size="mini" @click="isShowEditWindow = false"
          >取消</el-button
        >
        <el-button size="mini" type="primary" @click="creatEdit"
          >确定</el-button
        >
      </div>
    </jdialog>
    <!-- 删除弹窗 -->
     <el-dialog
      :visible.sync="isShowDeletetWindow"
      width="30%"
      center>
      <span>确认删除{{classfyDeleteItem}}分类，删除后取消关联分类中的商品</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowDeletetWindow = false">取 消</el-button>
        <el-button type="primary" @click="creatDel">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import uploadImg from "@/components/uploadImg";
import { getClassfyActivityList, activityClassfyAddEdit,activityClassfyDelete } from '@/api/activity'
export default {
  components: {},
  data() {
    return {
      tableData: [],
      labelPosition: 'right',
      isShowAddWindow: false,
      isShowEditWindow: false,
      isShowDeletetWindow: false,
      classfyDeleteItem: '',
      deleteInfo: {},
      form: {
        page: 1
      },
      total: 0,
      addWindowInfo: {
        activity_id: '',
        sort_name: '',
        sort_order: '',
        activity_name: ''
      },
      windowInfo: {
        id:'',
        activity_id: '',
        sort_name: '',
        sort_order: '',
        activity_name: ''
      },
      activits: []
    }
  },
  mounted() {
    this.getClassfyActivityList()
  },
  methods: {
    //获取列表数据
    async getClassfyActivityList() {
      let url = `page=${this.form.page}`
      let res = await getClassfyActivityList(url)
      console.log(res)
      if (res.code === 10000) {
        this.activits = res.data.activity
        this.tableData = res.data.data
        this.total = res.data.total
      } else {
        this.$message.error(res.message)
      }
    },

    // 删除
    deleteItem(info) {
      this.isShowDeletetWindow = true
      this.classfyDeleteItem = info.sort_name
      this.deleteInfo = info
    },
    //显示添加弹窗
    addItem() {
      this.addWindowInfo.sort_name = ''
      this.addWindowInfo.sort_order = ''
      this.addWindowInfo.activity_id = ''
      this.addWindowInfo.activity_name = ''
      this.isShowAddWindow = true
    },
    //显示编辑弹窗
    editItem(info) {
      this.windowInfo.id = info.id
      this.windowInfo.sort_name = info.sort_name
      this.windowInfo.sort_order = info.sort_order
      this.windowInfo.activity_id = info.activity_id
      this.windowInfo.activity_name = info.activity_name
      this.isShowEditWindow = true
    },
    //确认添加
    async creatAdd() {
      let { activity_id } = this.addWindowInfo
      let label = this.activits.find(one => one.id === activity_id).name
      this.addWindowInfo.activity_name = label
      let res = await activityClassfyAddEdit(this.addWindowInfo)
      if (res.code === 10000) {
        this.getClassfyActivityList()
        this.$message.success(res.message)
        this.isShowAddWindow = false
      } else {
        this.$message.error(res.message)
      }
    },
    //确认编辑
    async creatEdit() {
      let res = await activityClassfyAddEdit(this.windowInfo)
      if (res.code === 10000) {
        // this.windowInfo = res.data
        this.getClassfyActivityList()
        this.isShowEditWindow = false
        this.$message.success(res.message)
      } else {
        this.$message.error(res.message)
      }
    },
    // 确认删除
    async creatDel() {
      let id = this.deleteInfo.id
      let activity_id = this.deleteInfo.activity_id
      let res = await activityClassfyDelete({
        id: id,
        activity_id: activity_id
      })
      if (res.code === 10000) {
        this.getClassfyActivityList()
        this.isShowDeletetWindow = false
        this.$message.success(res.message)
      } else {
        this.$message.error(res.message)
      }
    },
    // 分页设置
    pageChange(page) {
      this.form.page = page
      //获取更多数据
      this.getClassfyActivityList()
    },
    
    tc() {
      return 'text-align:center; color:#333333; font-size:12px;'
    },
    tccolor() {
      return 'text-align:center;background-color:#f5f5f5; font-size:14px;'
    }
  }
}
</script>
<style lang="scss" scoped>
.shop {
  padding: 20px;
  .pagination {
    float: right;
    margin-top: 12px;
  }
  .align {
    text-align: center;
    padding-bottom: 20px;
  }
  .demo-ruleForm {
    padding: 20px;
    .remarkarea {
      padding-right: 30px;
      margin-top: 20px;
    }
  }
}
</style>
